import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import LineChart from '../../../shared/components/LineChart/LineChart';
import { useActiveCallsData } from '../../hooks/useActiveCallsData';
import styles from './activeCalls.module.scss';

export default memo(function ActiveCalls(props) {
    const { t } = useTranslation(['dashboard', 'common']);

    useActiveCallsData(props.getActiveCallsRequest);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <span className={styles.title}>{t('dashboard:active_calls')}</span>
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:active_calls_detail')}
                    >
                        <span className={styles.subtitle}>{t('dashboard:active_calls_detail')}</span>
                    </Tooltip>
                </div>
                {props.activeCalls.fetching && <CircularLoader light size={24} />}
                {
                    !props.activeCalls.fetching &&
                    props.activeCalls.error &&
                    props.activeCalls.calls &&
                    props.activeCalls.calls.categories &&
                    props.activeCalls.calls.calls &&
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:update_error')}
                    >
                        <div>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                        </div>
                    </Tooltip>
                }
            </div>
            {
                props.activeCalls.error &&
                !props.activeCalls.calls &&
                <div className={styles.cloudError}>
                    <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                    <span>{t('common:no_information_available')}</span>
                </div>
            }
            {
                props.activeCalls.calls &&
                props.activeCalls.calls.categories &&
                props.activeCalls.calls.calls &&
                <div className={styles.informationContainer}>
                    <LineChart
                        categories={props.activeCalls.calls.categories}
                        data={props.activeCalls.calls.calls}
                        dataName="Calls"
                        height={200}
                        type="datetime"
                    />
                </div>
            }
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.activeCalls === nextProps.activeCalls &&
        prevProps.getActiveCallsRequest === nextProps.getActiveCallsRequest
);
